/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { Render } from '@adobe-commerce/elsie/lib';
import { Provider } from '@/company-switcher/render/Provider';

/**
 * Render instance for the company switcher drop-in.
 * Wraps the Provider component to handle initialization and rendering.
 */
export const render = new Render(<Provider />);
